import { render } from "./FilterIcon.vue?vue&type=template&id=6ef1a814"
import script from "./FilterIcon.vue?vue&type=script&lang=js"
export * from "./FilterIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__